import { DO_NOT_USE_FaWrapper } from '../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { Box } from '../../../foundation/Box/index.js';
import { ToastContainer, Title, Message } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useTransitionState } from '../../../../hooks/useTransitionState/index.js';
import { IconButton } from '../../../navigation/buttons/IconButton/index.js';
import { Button } from '../../../navigation/buttons/Button/Button.js';

function Toast(props) {
  var onClose = props.onClose,
    _props$appearance = props.appearance,
    appearance = _props$appearance === void 0 ? 'info' : _props$appearance,
    title = props.title,
    message = props.message,
    action = props.action,
    visible = props.visible;
  var transitionState = useTransitionState(visible, 200);
  var handleActionClick = function handleActionClick() {
    action === null || action === void 0 ? void 0 : action.onClick();
    onClose();
  };
  return /*#__PURE__*/jsxs(ToastContainer, {
    $transitionState: transitionState,
    $appearance: appearance,
    children: [/*#__PURE__*/jsxs(Box, {
      flexDirection: "column",
      width: "100%",
      children: [/*#__PURE__*/jsxs(Box, {
        width: "100%",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: "xl",
        children: [/*#__PURE__*/jsx(Title, {
          $fontWeight: "bold",
          children: title
        }), /*#__PURE__*/jsx(IconButton, {
          type: "button",
          $round: true,
          onClick: onClose,
          appearance: "glass",
          size: "xs",
          children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
            icon: faXmark
          })
        })]
      }), message && /*#__PURE__*/jsx(Message, {
        $fontSize: "small",
        children: message
      })]
    }), action && /*#__PURE__*/jsx(Button, {
      type: "button",
      onClick: handleActionClick,
      appearance: "glass",
      size: "xs",
      children: action.label
    })]
  });
}

export { Toast };
